<div class="modal-header">
  <h5 class="modal-title">
    <ng-container i18n>Property Summary</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body m-3">
  <app-loading-section *ngIf="isLoading"></app-loading-section>
  <div class="table-responsive" *ngIf="!isLoading">
    <table class="table table-bordered table-striped">
      <tr>
        <td><strong i18n>Status: </strong></td>
      </tr>

      <tr>
        <td>
          {{ summary?.status }}
        </td>
      </tr>
      <tr>
        <td><strong i18n>Warnings: </strong></td>
      </tr>

      <tr>
        <td>
          <textarea class="w-100" [rows]="summary?.warnings?.length || 2" disabled cdkTextareaAutosize>{{
            getText('warnings')
          }}</textarea>
        </td>
      </tr>
      <tr>
        <td><strong i18n>Errors: </strong></td>
      </tr>

      <tr>
        <td>
          <textarea class="w-100" [rows]="summary?.errors?.length || 2" disabled cdkTextareaAutosize>{{
            getText('errors')
          }}</textarea>
        </td>
      </tr>
    </table>
  </div>
</div>
